import {
    apiRequest,
    dokumenpelantikanList,
    dokumenpelantikanActive,
    dokumenpelantikanInactive
} from "../../../../../services/adapters/kepegawaian/dokumenPelantikanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", dokumenpelantikanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", dokumenpelantikanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", dokumenpelantikanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository